<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Pickups',
        route: { name: 'customerservice-accounts-account-pickups', params: this.$route.params }
      }
    }
  }
}
</script>
